
import { z } from "zod";

export const TagColorHexValues = ["EAF7F9", "EEF7EE", "F0F0F0", "F0FBFF", "F3EEF9", "F7F7F7", "FCEEFB", "FDF9EA", "FEEEEE", "FEF5E8"] as const;
export const TagColorHexSchema = z.enum(TagColorHexValues);
export const TagColorHex = TagColorHexSchema.enum;
export type TagColorHex = (typeof TagColorHexValues)[number];
export const TagColorHexDisplayNames = { "EAF7F9": "Teal",
"EEF7EE": "Green",
"F0F0F0": "Dark Gray",
"F0FBFF": "Blue",
"F3EEF9": "Purple",
"F7F7F7": "Gray",
"FCEEFB": "Pink",
"FDF9EA": "Yellow",
"FEEEEE": "Red",
"FEF5E8": "Orange", } satisfies Record<TagColorHex, string>;
